<template>
  <Card class="contract-accept">
    <template #default>
      <Loader :value="promise" theme="default" :message="$t('signingLoadingMessage') + '...'">
        <iframe :src="value.acceptUrl" class="contract__sign" frameborder="0"></iframe>
      </Loader>
    </template>
    <template #footer>
      <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('cancel')" />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      promise: null,
    }
  },
  methods: {
    onSignSuccess(data) {
      this.promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
          this.$emit('accepted')
        }, 15000)
      })
    },
    onSignCanceled(data) {
      this.$emit('cancel')
    },
    onSignError(data) {
      console.log(data)
      this.$emit('cancel')
    },
    messageHandler(event) {
      if (!event.origin.endsWith('idfy.io')) return
      let data, type, payload

      try {
        data = JSON.parse(event.data)
        type = data.type
        payload = data.payload
      } catch (err) {}

      const handlers = {
        sign_success: 'onSignSuccess',
        sign_canceled: 'onSignCanceled',
        sign_error: 'onSignError',
      }

      if (!handlers[type]) return
      return this[handlers[type]](payload)
    },
  },
  created() {
    window.addEventListener('message', this.messageHandler, false)
  },
  mounted() {
    this.$el.closest('.view').scrollIntoView({ behavior: 'smooth' })
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageHandler)
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.contract-accept {
}
</style>
